export default __webpack_public_path__ + "static/suzanne-agterberg-9d53810bc18bba46f1fa63e398f0fd65.jpg";